<template>
  <a-spin :spinning="isLoading">
    <a-row :gutter="16">
      <a-col :span="12">
        <div class="label">
          {{ $t('shared.startDay') }}
        </div>
        <a-date-picker
          v-model:value="startDay"
          class="date-picker"
          :disabled-date="disabledDateForStartDay"
          @change="onSave"
        />
      </a-col>
      <a-col :span="12">
        <div class="label">
          {{ $t('shared.finishDay') }}
        </div>
        <a-date-picker
          v-model:value="finishDay"
          class="date-picker"
          :disabled-date="disabledDateForFinishDay"
          @change="onSave"
        />
      </a-col>
    </a-row>
    <div class="label">
      {{ $t('shared.progress') }}
    </div>
    <a-input-number
      v-model:value="progress"
      :min="0"
      :max="100"
      :step="5"
      :formatter="value => `${value}%`"
      :parser="value => value.replace('%', '')"
      :style="{ width: '100%'}"
      @blur="e => onSave()"
    />
  </a-spin>
</template>

<script>
import { ref } from 'vue'

import STATE_OPTIONS from '@/constants/state-options'
import { calculateStatus } from '@/utils/calculateStatus'
import moment from 'moment'

const STATE_MAP = STATE_OPTIONS.reduce((obj, state) => {
  obj[state.value] = state.color
  return obj
}, {})

export default {
  props: {
    keyResult: {
      type: Object,
      required: true
    }
  },
  emits: ['progress-updated'],
  setup (props, { emit }) {
    const isLoading = ref(false)
    const giveUpStatus = ref(props.keyResult.stateId.id === 4)

    const startDay = ref(
      props.keyResult.startDay ? moment(props.keyResult.startDay) : undefined
    )
    const finishDay = ref(
      props.keyResult.endDay ? moment(props.keyResult.endDay) : undefined
    )

    const progress = ref(props.keyResult.progress)

    function getStatus () {
      if (giveUpStatus.value) {
        return 4
      } else {
        return calculateStatus(
          startDay.value,
          finishDay.value,
          progress.value
        ) || props.keyResult.stateId.id
      }
    }

    function onSave () {
      emit('progress-updated', {
        progress: progress.value,
        start_day: startDay.value?.unix() || 0,
        finish_day: finishDay.value?.unix() || 0,
        state_id: getStatus()
      })
    }

    function disabledDateForFinishDay (date) {
      return startDay.value && date.isBefore(startDay.value)
    }

    function disabledDateForStartDay (date) {
      return finishDay.value && date.isAfter(finishDay.value)
    }

    return {
      isLoading,
      startDay,
      finishDay,
      progress,
      stateOptions: STATE_OPTIONS,
      stateMap: STATE_MAP,
      giveUpStatus,
      onSave,
      disabledDateForFinishDay,
      disabledDateForStartDay
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-row) {
  margin-bottom: 24px;
}
:deep(.ant-input-number) {
  width: 100%;
}
.state-option {
  display: block;
  height: 30px;
  line-height: 30px;

  :deep(.ant-radio-inner) {
    border-color: var(--color) !important;

    &:after {
      background-color: var(--color) !important;
    }
  }
}

.date-picker {
  width: 100%;
}

.label {
  font-weight: 700;
  margin-bottom: 8px;
}
</style>
